import { computed, defineComponent, onMounted, onUnmounted, onUpdated, ref } from 'vue';
import { useStore } from 'vuex';
import { RegionAction, RegionGetter } from '@/store/region/region.module';
import { Region } from '@/store/region/region.model';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'RegionTableComponent',
  components: {
    LoadingComponent
  },
  emits: [
    'edit'
  ],
  setup: (_, context) => {
    const store = useStore();
    const regions = computed<Region[]>(() => {
      const all = store.getters[RegionGetter.ALL] as Region[];
      return all.filter(m => m.id !== 1);
    });
    const isLoading = computed(() => store.getters[RegionGetter.STATUS] === 'init' || store.getters[RegionGetter.STATUS] === 'loading');
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();

    onMounted(() => {
      store.dispatch(RegionAction.FETCH)
        .then(() => initialDataTable());
    });

    onUpdated(() => initialDataTable());

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const initialDataTable = () => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => {
          const dt = datatable.value as HTMLTableElement;
          if (!$.fn.dataTable.isDataTable(dt)) {
            dtInstance.value = $(dt).DataTable({
              language: {
                emptyTable: 'ไม่พบข้อมูล',
                info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
                infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
                infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
                lengthMenu: 'แสดงข้อมูล _MENU_',
                paginate: {
                  next: 'ถัดไป',
                  previous: 'ก่อนหน้า',
                  first: 'First',
                  last: 'Last'
                },
                search: 'ค้นหา:',
                zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
              }
            });
          }
        });
      };

    const editClick = (id: number) => {
      context.emit('edit', id);
    };

    return {
      isLoading,
      regions,
      datatable,
      editClick
    };
  },
});
